import React from "react";
import { Box } from "@chakra-ui/react";
import dashboardIcon from "../semantic/themes/arangodb-oasis-default/assets/images/icons/primary/dashboard.svg";
import deploymentIcon from "../semantic/themes/arangodb-oasis-default/assets/images/icons/primary/deployment.svg";
import groupIcon from "../semantic/themes/arangodb-oasis-default/assets/images/icons/primary/group.svg";
import ipallowlistIcon from "../semantic/themes/arangodb-oasis-default/assets/images/icons/primary/icons/primary/ip-whitelist.svg";
import organizationInviteIcon from "../semantic/themes/arangodb-oasis-default/assets/images/icons/primary/organization-invite.svg";
import pricingIcon from "../semantic/themes/arangodb-oasis-default/assets/images/icons/primary/pricing.svg";
import projectIcon from "../semantic/themes/arangodb-oasis-default/assets/images/icons/primary/project.svg";
import roleBindingIcon from "../semantic/themes/arangodb-oasis-default/assets/images/icons/primary/role-binding.svg";
import roleIcon from "../semantic/themes/arangodb-oasis-default/assets/images/icons/primary/role.svg";
import userIcon from "../semantic/themes/arangodb-oasis-default/assets/images/icons/primary/user.svg";
import { TopMenuImages } from "./TopMenuInfo";

interface ITopMenuIconViewArgs {
  imageSource?: TopMenuImages;
}

export const TopMenuIconView = ({ ...args }: ITopMenuIconViewArgs) => {
  let result = "";
  switch (args.imageSource) {
    case "dashboard":
      result = dashboardIcon;
      break;
    case "user":
      result = userIcon;
      break;
    case "organization-invites":
    case "organization-invite":
      result = organizationInviteIcon;
      break;
    case "organizations":
    case "organization":
      result = groupIcon;
      break;
    case "pricing":
      result = pricingIcon;
      break;
    case "projects":
    case "project":
      result = projectIcon;
      break;
    case "groups":
    case "group":
      result = groupIcon;
      break;
    case "roles":
    case "role":
      result = roleIcon;
      break;
    case "deployments":
    case "deployment":
      result = deploymentIcon;
      break;
    case "role-bindings":
    case "role-binding":
      result = roleBindingIcon;
      break;
    case "ipallowlist":
    case "ipallowlists":
      result = ipallowlistIcon;
      break;
  }

  if (result != "") {
    return (
      <Box
        width="100%"
        height="100%"
        sx={{
          maskImage: `url(${result})`,
          WebkitMaskImage: `url(${result})`,
          maskSize: "contain",
          WebkitMaskSize: "contain",
          maskRepeat: "no-repeat",
          WebkitMaskRepeat: "no-repeat",
          maskPosition: "center",
          WebkitMaskPosition: "center",
        }}
        bgColor="green.600"
      />
    );
  }
  return <Box width="100%" height="100%" />;
};
